"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

/* The org's tags for an add-patient form's Tags field (D-96): an empty list
 * until they load, null with no org (the form then has no Tags field). Every
 * add-patient dialog, the patient table's and the chat's, reads them here. */
const useOrgPatientTags = (orgKey) => {
  const [tags, setTags] = _react.useState(null)
  _react.useEffect.call(void 0, 
    () => {
      if (!orgKey) return
      let isCurrent = true
      _actions2.default.listPatientTags({ OrgKey: orgKey })
        .then(r => isCurrent && setTags({ orgKey, tags: r.Tags }))
        .catch(() => undefined)
      return () => { isCurrent = false }
    },
    [orgKey],
  )
  return orgKey ? (_optionalChain([tags, 'optionalAccess', _ => _.orgKey]) === orgKey ? tags.tags : []) : null
}

exports. default = useOrgPatientTags
